<template>
  <div class="homescreen" :style="color">
    <div class="homeprofile">
      <div class="homeheader columns is-mobile">
        <div class="column is-3">
          <a @click="isAuthenticated ? router('/profile') : router('/login')">
            <div
              v-bind:style="{ 'background-image': image }"
              v-if="!isAuthenticated || $store.state.profile.picture === ''"
              class="homeprofileimg"
            ></div>
            <div
              :style="$store.state.profile.picture"
              v-else
              class="homeprofileimg"
            ></div>
          </a>
        </div>
        <div class="column is-7">
          <h6 class="home title" :style="textColor">
            Hi
            <span>
              <span
                v-if="!isAuthenticated || $store.state.profile.fname === ''"
                class="preload"
                style="width: 100px"
              ></span>
              <span v-else>{{ $store.state.profile.fname }}</span>
            </span>
            <img src="../assets/img/hi.png" width="28px" />
          </h6>
        </div>
        <div class="column is-2">
          <a @click="router('/search')" class="searchIcon">
            <i class="fas fa-search"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="columns">
        <!-- video -->
        <div class="column is-4">
          <div class="grand-challenge columns is-hidden">
            <div class="column">
              <div class="card" @click="router(route)">
                <a class="gc-next">
                  <i class="fas fa-chevron-circle-right"></i>
                </a>
                <div
                  class="card-content"
                  v-bind:style="{ 'background-image': banner }"
                >
                  <div class="featured-banner" style="margin: 0px !important">
                    #{{ hashtag }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <video-player
            v-if="vid1.loaded"
            class="vjs-custom-skin"
            ref="videoPlayer"
            :options="vid1"
            :playsinline="true"
          ></video-player>
          <img class="vjs-image" :src="product.banner" alt="" />
        </div>
        <!-- /video -->
        <!-- projects -->
        <div class="column">
          <div v-if="projectstatus">
            <div
              class="preload dark"
              style="height: 32px; width: 100%; margin: 10px 0"
            ></div>
            <div class="preload dark" style="height: 120px; width: 100%"></div>
            <div
              class="preload dark"
              style="height: 32px; width: 100%; margin: 10px 0"
            ></div>
            <div class="preload dark" style="height: 120px; width: 100%"></div>
          </div>
          <div v-else class="columns">
            <div style="padding: 0 13px" class="column">
              <div
                style="padding: 0 13px"
                class="column"
                v-if="similarProjects.length > 0"
              >
                <div style="padding-bottom: 13px">
                  <span class="tag preview-headline is-medium is-info"
                    >Recommended for you</span
                  >
                </div>

                <div class="scrollingwrapper">
                  <a
                    @click="router('/project/' + project.id)"
                    class="scrolling-card"
                    :key="project.index"
                    v-for="project in similarProjects"
                  >
                    <v-lazy-image
                      :src-placeholder="require('@/assets/img/home-lazy.png')"
                      :src="project.image"
                      @error="
                        post.thumbnail = require('@/assets/img/home-lazy.png')
                      "
                    />
                  </a>
                </div>
              </div>

              <div v-for="(level, levelIndex) in levels" :key="level.index || levelIndex">
                <div class="column level-header-container">
                  <h6 class="preview-headline subtitle is-hidden">
                    {{ level.name }}
                  </h6>
                  <span class="tag preview-headline is-medium is-info">{{
                    level.name
                  }}</span>
                </div>
                <div class="column">
                  <!-- Level Video (conditionally rendered when video data exists) -->
                  <video-player
                    v-if="level.video && level.video.loaded && !level.video.error"
                    class="vjs-custom-skin level-video"
                    :ref="`levelVideoPlayer${levelIndex}`"
                    :options="level.video"
                    :playsinline="true"
                    @ready="onLevelVideoReady(levelIndex, level)"
                    @error="onLevelVideoError(levelIndex, level, $event)"
                  ></video-player>
                  
                  <!-- Loading state for projects -->
                  <div v-if="level.docs < 2">
                    <div
                      class="preload dark"
                      style="height: 150px; width: 100%"
                    ></div>
                  </div>
                  
                  <!-- Project thumbnails -->
                  <div v-else class="scrollingwrapper">
                    <a
                      @click="router('/project/' + project.id)"
                      class="scrolling-card"
                      :key="project.index"
                      v-for="project in level.docs"
                    >
                      <div v-if="project.done" class="done">
                        <i class="fas fa-check-circle"></i>
                      </div>
                      <v-lazy-image
                        v-bind:class="{ doneimg: project.done }"
                        :src-placeholder="require('@/assets/img/home-lazy.png')"
                        :src="project.image"
                        @error="
                          post.thumbnail = require('@/assets/img/home-lazy.png')
                        "
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns" v-if="comingsoon">
            <div class="column">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/witblox-5ae68.appspot.com/o/category%2Fcoming-soon.jpeg?alt=media&token=1d1bad58-a610-4f8b-b62e-1b5489250f05"
                alt=""
              />
            </div>
          </div>
          <div class="columns">
            <div class="column" style="padding-top: 50px"></div>
          </div>
        </div>
        <!-- /projects -->
      </div>
    </div>
  </div>
</template>
<script>
// import { Plugins } from "@capacitor/core";
import { auth } from "@/main.js";
import { db } from "@/main.js";
// const { App } = Plugins;
import VLazyImage from "v-lazy-image";
import { videoPlayer } from "vue-video-player";
export default {
  name: "category",
  components: {
    VLazyImage,
    videoPlayer,
  },
  data() {
    return {
      isAuthenticated: false,
      projectstatus: true,
      image: "url(" + require("@/assets/img/user.png") + ")",
      message: "What would you like to build today?",
      challengetag: "#Challenge",
      cid: "",
      banner: "",
      coins: 0,
      levels: [],
      comingsoon: false,
      route: "",
      hashtag: "",
      similarProjects: [],
      recommendations: [],
      vid1: {
        height: "300",
        width: "100%",
        autoplay: true,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster: "",
        loaded: false,
      },
      product: {},
      // Flags to prevent loops and multiple simultaneous executions
      isProcessingProjects: false,
      projectDataWatcherTimeout: null,
    };
  },
  methods: {
    checkAuth() {
      // Check if user is logged in
      this.isAuthenticated = !!auth.currentUser;
    },
    
    router(name) {
      this.$router.push(name);
    },
    async fetcChallenge(id) {
      try {
        const doc = await db.collection("challenges").doc(id).get();
        if (doc.exists) {
          var c = doc.data();
          this.coins = c.coins;
          this.banner = "url(" + c.featuredImg + ")";
          this.cid = doc.id;
        }
      } catch (error) {
        console.error("Error fetching challenge:", error);
      }
    },
    fetchProjects() {
      // Prevent multiple simultaneous executions
      if (this.isProcessingProjects) {
        console.log("fetchProjects already in progress, skipping", {
          categoryId: this.$route.params.id,
          timestamp: new Date().toISOString()
        });
        return;
      }
      
      this.isProcessingProjects = true;
      this.levels = [];
      this.projectstatus = true;
      this.comingsoon = false;
      
      // Check if categories are available in the store
      if (this.$store.state && this.$store.state.categories) {
        this.$store.state.categories.forEach((ctgry) => {
          if (ctgry.id == this.$route.params.id) {
            this.banner = "url(" + ctgry.banner + ")";
            this.route = ctgry.route;
            this.hashtag = ctgry.hashtag;
          }
        });
      }
      
      // Check if categoryData is available in the store
      if (this.$store.state && this.$store.state.categoryData) {
        const foundCategory = this.$store.state.categoryData.find(
          category => category.id === this.$route.params.id
        );
        
        if (foundCategory) {
          console.log("Using category data from store", {
            categoryId: this.$route.params.id,
            hasLevels: !!foundCategory.levels,
            levelCount: foundCategory.levels?.length || 0,
            hasProduct: !!foundCategory.product,
            isAuthenticated: this.isAuthenticated,
            timestamp: new Date().toISOString()
          });
          
          if (foundCategory.levels) {
            const homepage = [];
            
            foundCategory.levels.forEach(level => {
              const prjct = [];
              const lvl = { name: level.name, docs: prjct };
              
              // Process video data for the level if available
              if (level.video && this.validateVideoData(level.video)) {
                console.log("Processing level video data from store", {
                  levelName: level.name,
                  videoUrl: level.video.url,
                  hasPoster: !!level.video.poster,
                  timestamp: new Date().toISOString()
                });
                lvl.video = this.generateLevelVideoConfig(level.video);
              }
              
              if (level.projects && level.projects.length > 0) {
                level.projects.forEach(project => {
                  if (this.$store.state.projectData) {
                    const projectData = this.$store.state.projectData.find(
                      pdata => pdata.id === project
                    );
                    
                    if (projectData) {
                      // For store-based data, the 'done' status is already calculated
                      // based on authentication status in the store's getProjectData method
                      prjct.push({
                        id: projectData.id,
                        image: projectData.featuredImg,
                        done: this.isAuthenticated ? !!projectData.done : false,
                      });
                    }
                  }
                });
              }
              
              homepage.push(lvl);
            });
            
            console.log("Store-based level processing completed", {
              categoryId: this.$route.params.id,
              processedLevels: homepage.length,
              levelsWithVideos: homepage.filter(l => l.video).length,
              timestamp: new Date().toISOString()
            });
            
            this.levels = homepage;
            this.projectstatus = false;
            
            // Initialize level videos after levels are loaded
            this.$nextTick(() => {
              this.initializeLevelVideos();
            });
            
            // Reset processing flag
            this.isProcessingProjects = false;
            
            if (foundCategory.product) {
              this.product = foundCategory.product;
              
              if (foundCategory.product.video) {
                this.vid1.sources = [{
                  type: "video/mp4",
                  src: foundCategory.product.video,
                }];
                
                this.vid1.poster = foundCategory.product.image || "";
                this.vid1.loaded = true;
                
                console.log("Category product video configured from store", {
                  categoryId: this.$route.params.id,
                  videoUrl: foundCategory.product.video,
                  hasPoster: !!foundCategory.product.image,
                  timestamp: new Date().toISOString()
                });
              }
            }
          } else {
            console.log("No levels found in store category data, showing coming soon", {
              categoryId: this.$route.params.id,
              timestamp: new Date().toISOString()
            });
            this.comingsoon = true;
            // Reset processing flag
            this.isProcessingProjects = false;
          }
        } else {
          console.log("Category not found in store, falling back to direct fetch", {
            categoryId: this.$route.params.id,
            availableCategories: this.$store.state.categoryData.map(c => c.id),
            timestamp: new Date().toISOString()
          });
          // If category is not found in store, fetch it directly
          this.fetchCategoryData();
        }
      } else {
        // If categoryData is not in the store, fetch it directly
        this.fetchCategoryData();
      }
    },
    async fetchCategoryData() {
      try {
        console.log("Fetching category data directly from Firestore", {
          categoryId: this.$route.params.id,
          isAuthenticated: this.isAuthenticated,
          timestamp: new Date().toISOString()
        });
        
        const categoryDoc = await db.collection("category").doc(this.$route.params.id).get();
        
        if (categoryDoc.exists) {
          const category = categoryDoc.data();
          
          console.log("Category data fetched successfully", {
            categoryId: this.$route.params.id,
            hasLevels: !!category.levels,
            levelCount: category.levels?.length || 0,
            hasProduct: !!category.product,
            timestamp: new Date().toISOString()
          });
          
          var homepage = [];
          if (category.levels) {
            for (const level of category.levels) {
              var prjct = [];
              var lvl = { name: level.name, docs: prjct };
              
              // Process video data for the level if available
              if (level.video && this.validateVideoData(level.video)) {
                console.log("Processing level video data", {
                  levelName: level.name,
                  videoUrl: level.video.url,
                  hasPoster: !!level.video.poster,
                  timestamp: new Date().toISOString()
                });
                lvl.video = this.generateLevelVideoConfig(level.video);
              }
              
              if (level.projects && level.projects.length > 0) {
                for (const projectId of level.projects) {
                  try {
                    const projectDoc = await db.collection("projects").doc(projectId).get();
                    if (projectDoc.exists) {
                      const projectData = projectDoc.data();
                      
                      // For authenticated users, check if they've completed the project
                      let isDone = false;
                      if (this.isAuthenticated && auth.currentUser) {
                        try {
                          const userProjectQuery = await db
                            .collection("users")
                            .doc(auth.currentUser.uid)
                            .collection("projects")
                            .where("pid", "==", projectId)
                            .get();
                          
                          isDone = !userProjectQuery.empty;
                        } catch (userErr) {
                          console.warn(`Error checking user project completion for ${projectId}:`, userErr);
                          isDone = false;
                        }
                      }
                      
                      prjct.push({
                        id: projectId,
                        image: projectData.featuredImg || "",
                        done: isDone,
                      });
                    }
                  } catch (err) {
                    console.error(`Error fetching project ${projectId}:`, err);
                  }
                }
              }
              
              homepage.push(lvl);
            }
            
            console.log("Level processing completed", {
              categoryId: this.$route.params.id,
              processedLevels: homepage.length,
              levelsWithVideos: homepage.filter(l => l.video).length,
              timestamp: new Date().toISOString()
            });
          } else {
            console.log("No levels found in category, showing coming soon", {
              categoryId: this.$route.params.id,
              timestamp: new Date().toISOString()
            });
            this.comingsoon = true;
          }
          
          this.levels = homepage;
          this.projectstatus = false;
          
          // Initialize level videos after levels are loaded
          this.$nextTick(() => {
            this.initializeLevelVideos();
          });
          
          // Reset processing flag
          this.isProcessingProjects = false;
          
          if (category.product) {
            this.product = category.product;
            
            if (category.product.video) {
              this.vid1.sources = [{
                type: "video/mp4",
                src: category.product.video,
              }];
              
              this.vid1.poster = category.product.image || "";
              this.vid1.loaded = true;
              
              console.log("Category product video configured", {
                categoryId: this.$route.params.id,
                videoUrl: category.product.video,
                hasPoster: !!category.product.image,
                timestamp: new Date().toISOString()
              });
            }
          }
        } else {
          console.warn("Category document not found", {
            categoryId: this.$route.params.id,
            timestamp: new Date().toISOString()
          });
          this.comingsoon = true;
        }
      } catch (error) {
        console.error("Error fetching category data:", {
          error: error.message,
          stack: error.stack,
          categoryId: this.$route.params.id,
          timestamp: new Date().toISOString()
        });
        this.comingsoon = true;
      }
    },
    async fetchRecommendations() {
      // Only fetch recommendations if the user is authenticated
      if (!this.isAuthenticated) {
        // For non-authenticated users, show no recommendations or fetch generic ones
        return;
      }
      
      try {
        const userProjects = await db
          .collection("users")
          .doc(auth.currentUser.uid)
          .collection("projects")
          .orderBy("created", "desc")
          .get();

        // If the user has no projects, exit early
        if (userProjects.empty) return;

        const lastProject = userProjects.docs[0];
        const lastProjectId = lastProject.data().pid;

        const categoriesConfig = await db
          .collection("config")
          .doc("categories")
          .get();

        const allProjects = categoriesConfig.data().recommended_projects;

        // Find the last project in the recommended projects array
        const lastProjectInArr = allProjects.find(
          (project) => project.id === lastProjectId
        );
        
        // If the last project is not found, exit early
        if (!lastProjectInArr) return;

        const lastProjectCategory = lastProjectInArr.category_id;

        // Find all the projects in the same category as the last project
        let similarProjects = allProjects.filter(
          (project) => project.category_id === lastProjectCategory
        );

        // remove projects that the user has already done
        const userProjectsIds = userProjects.docs.map(
          (project) => project.data().pid
        );

        similarProjects = similarProjects.filter(
          (project) => !userProjectsIds.includes(project.id)
        );

        // if there are less than 3 projects in the category, show all of them
        if (similarProjects.length <= 3) {
          this.similarProjects = similarProjects;
        } else {
          // Get 3 projects with different levels easy, medium, hard
          const easyProject = similarProjects.find(
            (project) => parseInt(project.level) === 1
          );

          const mediumProject = similarProjects.find(
            (project) => parseInt(project.level) === 2
          );

          const hardProject = similarProjects.find(
            (project) => parseInt(project.level) > 2
          );

          this.similarProjects = [easyProject, mediumProject, hardProject].filter(Boolean);
        }
      } catch (error) {
        console.error("Error fetching recommendations:", error);
      }
    },
    generateLevelVideoConfig(videoData) {
      // Generate video player configuration for level videos
      try {
        if (!videoData || !videoData.url) {
          console.warn("Level video: Invalid video data provided for level video configuration", {
            videoData: videoData,
            timestamp: new Date().toISOString()
          });
          return null;
        }

        // Validate video URL format
        if (!this.isValidVideoUrl(videoData.url)) {
          console.error("Level video: Invalid video URL format", {
            url: videoData.url,
            timestamp: new Date().toISOString()
          });
          return null;
        }

        const levelVideoConfig = {
          height: "200",
          width: "100%",
          autoplay: false,
          muted: true,
          language: "en",
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: "video/mp4",
            src: videoData.url,
          }],
          poster: videoData.poster || "",
          loaded: true,
          error: false,
          // Additional configuration for level videos
          fluid: true,
          responsive: true,
          controls: true,
          preload: 'metadata',
          // Error handling configuration
          errorDisplay: true,
          // Unique identifier for cleanup and debugging
          playerId: `level-video-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          // Retry configuration
          retryAttempts: 0,
          maxRetryAttempts: 2,
        };

        console.log("Level video: Successfully generated video configuration", {
          playerId: levelVideoConfig.playerId,
          url: videoData.url,
          hasPoster: !!videoData.poster,
          timestamp: new Date().toISOString()
        });

        return levelVideoConfig;
      } catch (error) {
        console.error("Level video: Error generating level video configuration", {
          error: error.message,
          stack: error.stack,
          videoData: videoData,
          timestamp: new Date().toISOString()
        });
        return null;
      }
    },
    
    initializeLevelVideos() {
      // Initialize video players for all levels with video data
      try {
        this.levels.forEach((level, index) => {
          if (level.video && level.video.loaded) {
            // Set up video player event listeners and initialization logic
            this.$nextTick(() => {
              const videoElement = this.$refs[`levelVideoPlayer${index}`];
              if (videoElement && videoElement.player) {
                this.setupLevelVideoEvents(videoElement.player, level);
              }
            });
          }
        });
      } catch (error) {
        console.error("Error initializing level videos:", error);
      }
    },
    
    setupLevelVideoEvents(player, level) {
      // Set up event listeners for level video players with comprehensive error handling
      try {
        if (!player) {
          console.warn("Level video: No player provided for event setup", {
            levelName: level?.name,
            timestamp: new Date().toISOString()
          });
          return;
        }
        
        const playerId = level.video?.playerId || 'unknown';
        
        // Handle video ready event
        player.ready(() => {
          console.log("Level video: Player ready", {
            levelName: level.name,
            playerId: playerId,
            timestamp: new Date().toISOString()
          });
        });
        
        // Handle video error events with detailed logging
        player.on('error', (error) => {
          console.error("Level video: Player error event", {
            levelName: level.name,
            playerId: playerId,
            error: error,
            errorCode: error?.code,
            errorMessage: error?.message,
            timestamp: new Date().toISOString()
          });
          this.handleLevelVideoError(level, error);
        });
        
        // Handle video load events
        player.on('loadstart', () => {
          console.log("Level video: Load started", {
            levelName: level.name,
            playerId: playerId,
            timestamp: new Date().toISOString()
          });
        });
        
        // Handle successful video load
        player.on('loadeddata', () => {
          console.log("Level video: Data loaded successfully", {
            levelName: level.name,
            playerId: playerId,
            timestamp: new Date().toISOString()
          });
        });
        
        // Handle video metadata loaded
        player.on('loadedmetadata', () => {
          console.log("Level video: Metadata loaded", {
            levelName: level.name,
            playerId: playerId,
            duration: player.duration(),
            timestamp: new Date().toISOString()
          });
        });
        
        // Handle video ended event
        player.on('ended', () => {
          console.log("Level video: Playback ended", {
            levelName: level.name,
            playerId: playerId,
            timestamp: new Date().toISOString()
          });
        });
        
        // Handle video play/pause events for analytics or state management
        player.on('play', () => {
          console.log("Level video: Playback started", {
            levelName: level.name,
            playerId: playerId,
            currentTime: player.currentTime(),
            timestamp: new Date().toISOString()
          });
        });
        
        player.on('pause', () => {
          console.log("Level video: Playback paused", {
            levelName: level.name,
            playerId: playerId,
            currentTime: player.currentTime(),
            timestamp: new Date().toISOString()
          });
        });
        
        // Handle video stalled/waiting events
        player.on('waiting', () => {
          console.log("Level video: Buffering/waiting", {
            levelName: level.name,
            playerId: playerId,
            timestamp: new Date().toISOString()
          });
        });
        
        player.on('stalled', () => {
          console.warn("Level video: Playback stalled", {
            levelName: level.name,
            playerId: playerId,
            timestamp: new Date().toISOString()
          });
        });
        
        // Handle network state changes
        player.on('suspend', () => {
          console.log("Level video: Loading suspended", {
            levelName: level.name,
            playerId: playerId,
            timestamp: new Date().toISOString()
          });
        });
        
        // Handle video abort events
        player.on('abort', () => {
          console.warn("Level video: Loading aborted", {
            levelName: level.name,
            playerId: playerId,
            timestamp: new Date().toISOString()
          });
        });
        
        // Handle empty/no source events
        player.on('emptied', () => {
          console.warn("Level video: Media element emptied", {
            levelName: level.name,
            playerId: playerId,
            timestamp: new Date().toISOString()
          });
        });
        
      } catch (error) {
        console.error("Level video: Error setting up video events", {
          error: error.message,
          stack: error.stack,
          levelName: level?.name,
          playerId: level?.video?.playerId,
          timestamp: new Date().toISOString()
        });
      }
    },
    
    handleLevelVideoError(level, error) {
      // Handle video loading errors gracefully with retry logic
      try {
        console.error("Level video: Video error occurred", {
          levelName: level.name,
          error: error,
          currentRetryAttempts: level.video?.retryAttempts || 0,
          maxRetryAttempts: level.video?.maxRetryAttempts || 2,
          timestamp: new Date().toISOString()
        });
        
        if (!level.video) {
          console.error("Level video: No video configuration found for error handling");
          return;
        }
        
        // Increment retry attempts
        level.video.retryAttempts = (level.video.retryAttempts || 0) + 1;
        
        // Check if we should retry
        if (level.video.retryAttempts <= level.video.maxRetryAttempts) {
          console.log("Level video: Attempting retry", {
            levelName: level.name,
            retryAttempt: level.video.retryAttempts,
            maxRetryAttempts: level.video.maxRetryAttempts,
            timestamp: new Date().toISOString()
          });
          
          // Wait before retrying (exponential backoff)
          const retryDelay = Math.pow(2, level.video.retryAttempts - 1) * 1000; // 1s, 2s, 4s
          
          setTimeout(() => {
            this.retryLevelVideo(level);
          }, retryDelay);
          
        } else {
          // Max retries reached, mark as failed
          console.error("Level video: Max retry attempts reached, marking as failed", {
            levelName: level.name,
            retryAttempts: level.video.retryAttempts,
            maxRetryAttempts: level.video.maxRetryAttempts,
            timestamp: new Date().toISOString()
          });
          
          level.video.loaded = false;
          level.video.error = true;
          level.video.errorMessage = this.getVideoErrorMessage(error);
          
          // Force re-render to show fallback content
          this.$forceUpdate();
        }
        
      } catch (err) {
        console.error("Level video: Error in error handling", {
          error: err.message,
          stack: err.stack,
          levelName: level?.name,
          timestamp: new Date().toISOString()
        });
        
        // Fallback: mark video as failed
        if (level.video) {
          level.video.loaded = false;
          level.video.error = true;
        }
        this.$forceUpdate();
      }
    },
    
    retryLevelVideo(level) {
      // Retry loading a level video
      try {
        if (!level.video || !level.video.sources || level.video.sources.length === 0) {
          console.error("Level video: Cannot retry - invalid video configuration", {
            levelName: level.name,
            timestamp: new Date().toISOString()
          });
          return;
        }
        
        console.log("Level video: Retrying video load", {
          levelName: level.name,
          retryAttempt: level.video.retryAttempts,
          videoUrl: level.video.sources[0]?.src,
          timestamp: new Date().toISOString()
        });
        
        // Reset error state for retry
        level.video.error = false;
        level.video.loaded = true;
        
        // Force re-render to recreate video player
        this.$forceUpdate();
        
        // Re-initialize video after DOM update
        this.$nextTick(() => {
          this.initializeLevelVideos();
        });
        
      } catch (error) {
        console.error("Level video: Error during retry", {
          error: error.message,
          stack: error.stack,
          levelName: level?.name,
          timestamp: new Date().toISOString()
        });
        
        // Mark as failed if retry fails
        if (level.video) {
          level.video.loaded = false;
          level.video.error = true;
        }
        this.$forceUpdate();
      }
    },
    
    getVideoErrorMessage(error) {
      // Get user-friendly error message based on error type
      try {
        if (!error) return "Unknown video error occurred";
        
        // Check for common video error types
        if (error.code) {
          switch (error.code) {
            case 1:
              return "Video loading was aborted";
            case 2:
              return "Network error occurred while loading video";
            case 3:
              return "Video format not supported or corrupted";
            case 4:
              return "Video source not found or unavailable";
            default:
              return `Video error (code: ${error.code})`;
          }
        }
        
        // Check error message for common patterns
        if (error.message) {
          const message = error.message.toLowerCase();
          if (message.includes('network')) {
            return "Network connection issue";
          } else if (message.includes('format') || message.includes('codec')) {
            return "Video format not supported";
          } else if (message.includes('not found') || message.includes('404')) {
            return "Video file not found";
          } else if (message.includes('permission') || message.includes('403')) {
            return "Access denied to video";
          }
        }
        
        return "Video could not be loaded";
      } catch (err) {
        console.error("Level video: Error getting error message", err);
        return "Video error occurred";
      }
    },
    
    cleanupLevelVideos() {
      // Cleanup video players to prevent memory leaks
      try {
        console.log("Level video: Starting cleanup of level videos", {
          levelCount: this.levels.length,
          timestamp: new Date().toISOString()
        });
        
        this.levels.forEach((level, index) => {
          if (level.video) {
            const playerId = level.video.playerId || `level-${index}`;
            
            try {
              const videoElement = this.$refs[`levelVideoPlayer${index}`];
              if (videoElement && videoElement.player) {
                console.log("Level video: Disposing video player", {
                  levelName: level.name,
                  playerId: playerId,
                  timestamp: new Date().toISOString()
                });
                
                // Remove all event listeners before disposing
                videoElement.player.off();
                
                // Dispose of the video player
                videoElement.player.dispose();
                
                console.log("Level video: Successfully disposed video player", {
                  levelName: level.name,
                  playerId: playerId,
                  timestamp: new Date().toISOString()
                });
              }
            } catch (playerError) {
              console.error("Level video: Error disposing individual video player", {
                error: playerError.message,
                levelName: level.name,
                playerId: playerId,
                timestamp: new Date().toISOString()
              });
            }
          }
        });
        
        console.log("Level video: Completed cleanup of level videos", {
          timestamp: new Date().toISOString()
        });
        
      } catch (error) {
        console.error("Level video: Error cleaning up level videos", {
          error: error.message,
          stack: error.stack,
          timestamp: new Date().toISOString()
        });
      }
    },
    
    validateVideoData(videoData) {
      // Validate video data structure and content
      try {
        if (!videoData || typeof videoData !== 'object') {
          console.warn("Level video: Video data is not an object", {
            videoData: videoData,
            type: typeof videoData,
            timestamp: new Date().toISOString()
          });
          return false;
        }
        
        if (!videoData.url || typeof videoData.url !== 'string') {
          console.warn("Level video: Video URL is missing or invalid", {
            hasUrl: !!videoData.url,
            urlType: typeof videoData.url,
            videoData: videoData,
            timestamp: new Date().toISOString()
          });
          return false;
        }
        
        // Basic URL validation
        if (!this.isValidVideoUrl(videoData.url)) {
          console.error("Level video: Video URL failed validation", {
            url: videoData.url,
            timestamp: new Date().toISOString()
          });
          return false;
        }
        
        // Validate poster URL if provided
        if (videoData.poster && typeof videoData.poster === 'string') {
          if (!this.isValidVideoUrl(videoData.poster)) {
            console.warn("Level video: Invalid poster URL provided", {
              posterUrl: videoData.poster,
              timestamp: new Date().toISOString()
            });
            // Don't fail validation for invalid poster, just warn
          }
        }
        
        console.log("Level video: Video data validation successful", {
          url: videoData.url,
          hasPoster: !!videoData.poster,
          timestamp: new Date().toISOString()
        });
        
        return true;
      } catch (error) {
        console.error("Level video: Error validating video data", {
          error: error.message,
          stack: error.stack,
          videoData: videoData,
          timestamp: new Date().toISOString()
        });
        return false;
      }
    },
    
    isValidVideoUrl(url) {
      // Validate video URL format and supported domains
      try {
        if (!url || typeof url !== 'string') {
          return false;
        }
        
        // Basic URL pattern validation
        const urlPattern = /^https?:\/\/.+/;
        if (!urlPattern.test(url)) {
          return false;
        }
        
        // Check for supported video file extensions
        const videoExtensions = /\.(mp4|webm|ogg|avi|mov|wmv|flv|m4v)(\?.*)?$/i;
        const isVideoFile = videoExtensions.test(url);
        
        // Check for supported video hosting domains
        const supportedDomains = [
          'firebasestorage.googleapis.com',
          'storage.googleapis.com',
          'youtube.com',
          'youtu.be',
          'vimeo.com',
          'wistia.com',
          'jwplatform.com'
        ];
        
        const urlObj = new URL(url);
        const isDomainSupported = supportedDomains.some(domain => 
          urlObj.hostname.includes(domain)
        );
        
        // URL is valid if it's either a direct video file or from a supported domain
        const isValid = isVideoFile || isDomainSupported;
        
        if (!isValid) {
          console.warn("Level video: URL validation failed - unsupported format or domain", {
            url: url,
            hostname: urlObj.hostname,
            isVideoFile: isVideoFile,
            isDomainSupported: isDomainSupported,
            timestamp: new Date().toISOString()
          });
        }
        
        return isValid;
      } catch (error) {
        console.error("Level video: Error validating video URL", {
          error: error.message,
          url: url,
          timestamp: new Date().toISOString()
        });
        return false;
      }
    },
    
    onLevelVideoReady(levelIndex, level) {
      // Handle level video ready event
      try {
        console.log("Level video: Video player ready", {
          levelName: level.name,
          levelIndex: levelIndex,
          playerId: level.video?.playerId,
          timestamp: new Date().toISOString()
        });
        
        // Get the video player reference
        const videoElement = this.$refs[`levelVideoPlayer${levelIndex}`];
        if (videoElement && videoElement.player) {
          this.setupLevelVideoEvents(videoElement.player, level);
          
          // Reset retry attempts on successful load
          if (level.video) {
            level.video.retryAttempts = 0;
            level.video.error = false;
          }
        } else {
          console.warn("Level video: Video player element not found after ready event", {
            levelName: level.name,
            levelIndex: levelIndex,
            timestamp: new Date().toISOString()
          });
        }
      } catch (error) {
        console.error("Level video: Error handling video ready event", {
          error: error.message,
          stack: error.stack,
          levelName: level?.name,
          levelIndex: levelIndex,
          timestamp: new Date().toISOString()
        });
      }
    },
    
    onLevelVideoError(levelIndex, level, event) {
      // Handle level video error event
      try {
        console.error("Level video: Video player error event", {
          levelName: level.name,
          levelIndex: levelIndex,
          event: event,
          playerId: level.video?.playerId,
          timestamp: new Date().toISOString()
        });
        
        this.handleLevelVideoError(level, event);
      } catch (error) {
        console.error("Level video: Error handling video error event", {
          error: error.message,
          stack: error.stack,
          levelName: level?.name,
          levelIndex: levelIndex,
          timestamp: new Date().toISOString()
        });
        
        // Fallback error handling
        if (level && level.video) {
          level.video.loaded = false;
          level.video.error = true;
          level.video.errorMessage = "Video player error occurred";
          this.$forceUpdate();
        }
      }
    },
    getColor() {
      if (this.$store.state) {
        this.$store.commit("getColorInfo");
        this.color =
          "background: linear-gradient(360deg, #ffffff 0%, #ffffff 82%, " +
          (this.$store.state.selectedColor?.c1 || "#5743e1") +
          " 100%);";
        this.textColor = "color: " + (this.$store.state.selectedColor?.c2 || "#000000") + ";";
      } else {
        // Use default colors if store is not initialized
        this.color = "background: linear-gradient(360deg, #ffffff 0%, #ffffff 82%, #5743e1 100%);";
        this.textColor = "color: #000000;";
      }
    },
  },
  created() {
    this.checkAuth();
  },
  beforeMount() {
    this.getColor();
    this.fetchProjects();
    // Only fetch recommendations if authenticated
    if (this.isAuthenticated) {
      try {
        this.fetchRecommendations();
      } catch (error) {
        console.error("Error fetching recommendations:", error);
      }
    }
  },
  beforeDestroy() {
    // Cleanup video players when component is destroyed
    this.cleanupLevelVideos();
  },
  watch: {
    "$store.state.projectData": {
      handler: function () {
        // Clear existing timeout to debounce the calls
        if (this.projectDataWatcherTimeout) {
          clearTimeout(this.projectDataWatcherTimeout);
        }
        
        // Set a new timeout to debounce the fetchProjects call
        this.projectDataWatcherTimeout = setTimeout(() => {
          console.log("Project data watcher triggered, calling fetchProjects", {
            categoryId: this.$route.params.id,
            projectDataLength: this.$store.state.projectData?.length || 0,
            timestamp: new Date().toISOString()
          });
          this.fetchProjects();
        }, 500); // 500ms debounce delay
      },
      deep: false // Don't watch deep changes, just array length changes
    },
  },
};
</script>

<style scoped>
.vjs-custom-skin {
  height: 200px !important;
  margin-bottom: 10px;
}

.vjs-custom-skin .video-js,
.vjs-image {
  border-radius: 10px;
}

/* Level video specific styling */
.level-video {
  height: 200px !important;
  width: 100% !important;
  margin-bottom: 15px;
  border-radius: 10px;
  overflow: hidden;
}

.level-video .video-js {
  border-radius: 10px;
  background-color: #000;
}

/* Responsive design for level videos */
@media (max-width: 768px) {
  .level-video {
    height: 180px !important;
    margin-bottom: 12px;
  }
}

@media (max-width: 480px) {
  .level-video {
    height: 160px !important;
    margin-bottom: 10px;
  }
}

/* Ensure proper spacing between level videos and project thumbnails */
.level-video + .scrollingwrapper {
  margin-top: 10px;
}

.level-video + .preload {
  margin-top: 10px;
}
</style>